/* shim.js: jQuery UI was dropped from the pour (phone QA 8/26: 61 KB for a calendar nobody asked for). The template's
   functions.js still calls $('#calendar').datepicker(); this keeps that call harmless so the rest of functions.js
   (ticker, sidenav, clock) runs. Loads deferred, after plugins.js, before functions.js. */
(function () {
  if (window.jQuery && !jQuery.fn.datepicker) { jQuery.fn.datepicker = function () { return this; }; }
})();
